import PropTypes from 'prop-types';
import React from 'react';

import Grid from '../Grid/Grid';

import { ColumnGuide, Overlay, ScreenClass } from './DebugGrid.styles';

function DebugGrid(props) {
  const { visible } = props;

  if (!visible) {
    return null;
  }

  const getColKey = (index) => `column-${index}`;

  return (
    <Grid.ScreenClassRender
      render={(screenClass) => (
        <Overlay className="mui-fixed">
          <Grid.Container fluid={false} style={{ backgroundColor: 'pink' }}>
            <Grid.Row>
              {[...Array(12)].map((item, index) => (
                <Grid.Col xs={['xs', 'sm'].includes(screenClass) ? 2 : 1} key={getColKey(index)}>
                  <ColumnGuide />
                </Grid.Col>
              ))}
            </Grid.Row>
          </Grid.Container>
          <ScreenClass>{screenClass}</ScreenClass>
        </Overlay>
      )}
    />
  );
}

DebugGrid.propTypes = {
  /** Toggles visibility of the DebugGrid. */
  visible: PropTypes.bool
};

DebugGrid.defaultProps = {
  visible: true
};

export default DebugGrid;
